import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MuiSwitch from '@material-ui/core/Switch';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {},
  switch: {},
});

function LabeledSwitch({
  className,
  classes,
  hidden,
  label,
  value,
  helperText,
  ...rest
}) {
  return (
    <div>
      <MuiFormControlLabel
        label={label}
        className={classNames(classes.root, className)}
        control={
          <MuiSwitch
            className={classes.switch}
            variant="outlined"
            checked={value}
            {...rest}
          />
        }
        hidden={hidden}
      />
      <FormHelperText>
        {helperText}
      </FormHelperText>
    </div>
  );
}

LabeledSwitch.defaultProps = {
  className: '',
  label: '',
};

LabeledSwitch.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
};

export default withStyles(styles, { name: 'LabeledSwitch' })(LabeledSwitch);
